import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Tag } from 'ui/tags';
import {
  Body2,
  colors,
  duration,
  easing,
  mediumShadow,
  smallShadow,
  spacing,
  Subtitle1,
} from 'ui/theme';

export const Title = styled.div`
  align-items: center;
  display: inline-flex;
  grid-area: title;
  justify-content: start;
`;

export const Name = styled(Subtitle1)`
  margin-bottom: 0;
  margin-right: ${spacing.quarter};
  margin-top: 0;
`;

export const Details = styled(Body2)`
  color: ${colors.textSecondary};
  grid-area: details;
  margin-bottom: 0;
`;

export const CategoryTag = styled(Tag)`
  padding-left: ${spacing.half};
  padding-right: ${spacing.half};
`;

export const LogoContainer = styled.div`
  display: flex;
  grid-area: image;
`;

export const Wrapper = styled(Link)`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: ${spacing.base};
  grid-template-areas: 'image title' 'image details';
  padding: ${spacing.double};
  background-color: ${colors.white};
  ${smallShadow}
  border-radius: ${spacing.half};
  transition: box-shadow ${duration.short} ${easing.standard};

  &:hover {
    text-decoration: none;
    ${mediumShadow};
  }
`;
